import type { CSSProperties } from "react";

const MENU_HEIGHT_ESTIMATE = 220; // rough upper bound for a handful of dropdown__item rows
const GAP = 8;

// Computes a `position: fixed` style for a `.dropdown__menu`, anchored to the
// trigger button's current viewport position. Every list screen wraps its
// table in a `.panel` with `overflow: hidden` (needed to clip square corners
// under the panel's rounded border), which silently clips the menu's default
// `position: absolute` when it opens near the bottom of a long table —
// `position: fixed` escapes that ancestor's overflow entirely (nothing in
// this app's table chrome sets `transform`/`filter`/`contain`, which are the
// only things that would defeat this), and this also flips the menu upward
// when there isn't enough room below the trigger.
export function computeDropdownFixedStyle(
  trigger: HTMLElement,
  align: "left" | "right" = "right",
): CSSProperties {
  const rect = trigger.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom;
  const openUpward = spaceBelow < MENU_HEIGHT_ESTIMATE && rect.top > spaceBelow;

  // Explicitly set all four edges (the unused pair to "auto") — the
  // `.dropdown__menu` class still has `top`/`left` from its default
  // `position: absolute` styling, and setting only the active edge here
  // would leave those stale values in place, over-constraining the box and
  // squashing its height instead of just repositioning it.
  return {
    position: "fixed",
    top: openUpward ? "auto" : rect.bottom + GAP,
    bottom: openUpward ? window.innerHeight - rect.top + GAP : "auto",
    left: align === "right" ? "auto" : rect.left,
    right: align === "right" ? window.innerWidth - rect.right : "auto",
  };
}
